<template>
<img :src="logo" width="600px" height="150px"/>
</template>

<script>
export default {
  name: 'ProjectLogo',
  data() {
    return {
      logo: require('../images/logo3.png')
    }
  }
}
</script>
